<template>
    <div id="errored-queue">
        <div v-if="!erroredJobs.length" id="empty-printing-queue">
            <h2 class="text-center text-muted">
                <i class="fa fa-print mr-2"/>
                <span v-html="$t('ErroredQueue.erroredQueueEmpty')"/>
            </h2>
        </div>
        <div v-else>
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th v-html="$t('ErroredQueue.product')"/>
                        <th class="text-center" v-html="$t('ErroredQueue.order')"/>
                        <th class="text-center" v-html="$t('ErroredQueue.errorType')"/>
                        <th class="text-center" v-html="$t('ErroredQueue.actions')"/>
                    </tr>
                </thead>
                <tbody>
                    <PrintingQueueLine v-for="job of erroredJobs" :key="job._id" :job="job" @show-order-print-modal="showOrderPrintModal"/>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import PrintingQueueLine from "@/components/shared/Orders/Print/PrintingQueueModal/PrintingQueue/PrintingQueueLine";

export default {
    name: "ErroredQueue",
    components: { PrintingQueueLine },
    computed: { ...mapGetters("order", { erroredJobs: "erroredJobs" }) },
    methods: {
        showOrderPrintModal(order) {
            this.$emit("show-order-print-modal", order);
        },
    },
};
</script>

<style scoped>

</style>